import React from "react";
import {
  Box,
  FormControlLabel,
  InputLabel,
  RadioGroup,
  Radio,
  Select,
  MenuItem,
} from "@mui/material";

import { useStyles } from "../CreateLeague";
import { noOfPlayers } from "../mockData";

const SMPFields = ({ leagueData, handleFieldChange }) => {
  const classes = useStyles();

  return (
    <>
      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          3rd Position Play Off
        </InputLabel>

        <RadioGroup
          row
          value={leagueData.third_position_play_off}
          name="third_position_play_off"
        >
          <FormControlLabel
            value={true}
            control={<Radio />}
            label="ON"
            onChange={(e) =>
              handleFieldChange(e.target.value, "third_position_play_off")
            }
          />
          <FormControlLabel
            value={false}
            control={<Radio />}
            label="OFF"
            onChange={(e) =>
              handleFieldChange(e.target.value, "third_position_play_off")
            }
          />
        </RadioGroup>
      </Box>

      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          No. of Players
        </InputLabel>

        <Select
          fullWidth
          variant="outlined"
          name="no_of_players"
          value={leagueData.no_of_players}
          className={classes.textFieldStyles}
          onChange={(e) => handleFieldChange(e.target.value, "no_of_players")}
        >
          {noOfPlayers.map(({ id, number }) => (
            <MenuItem
              key={id}
              value={number}
            >
              {number}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </>
  );
};

export default SMPFields;
